<div class="alice" [ngClass]="design"></div>
